import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HelpOutlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"help_outline"}/>
}
